module.exports = __webpack_public_path__ + "img/clients_img_02.738e1d14.jpg";